"use strict";

exports.__esModule = true;
var WindowsZoneName;
(function (WindowsZoneName) {
  WindowsZoneName["DatelineStandardTime"] = "Dateline Standard Time";
  WindowsZoneName["UtcMinus_11"] = "UTC-11";
  WindowsZoneName["AleutianStandardTime"] = "Aleutian Standard Time";
  WindowsZoneName["HawaiianStandardTime"] = "Hawaiian Standard Time";
  WindowsZoneName["MarquesasStandardTime"] = "Marquesas Standard Time";
  WindowsZoneName["AlaskanStandardTime"] = "Alaskan Standard Time";
  WindowsZoneName["UtcMinus_09"] = "UTC-09";
  WindowsZoneName["PacificStandardTimeMexico"] = "Pacific Standard Time (Mexico)";
  WindowsZoneName["UtcMinus_08"] = "UTC-08";
  WindowsZoneName["PacificStandardTime"] = "Pacific Standard Time";
  WindowsZoneName["UsMountainStandardTime"] = "US Mountain Standard Time";
  WindowsZoneName["MountainStandardTimeMexico"] = "Mountain Standard Time (Mexico)";
  WindowsZoneName["MountainStandardTime"] = "Mountain Standard Time";
  WindowsZoneName["CentralAmericaStandardTime"] = "Central America Standard Time";
  WindowsZoneName["CentralStandardTime"] = "Central Standard Time";
  WindowsZoneName["EasterIslandStandardTime"] = "Easter Island Standard Time";
  WindowsZoneName["CentralStandardTimeMexico"] = "Central Standard Time (Mexico)";
  WindowsZoneName["CanadaCentralStandardTime"] = "Canada Central Standard Time";
  WindowsZoneName["SaPacificStandardTime"] = "SA Pacific Standard Time";
  WindowsZoneName["EasternStandardTimeMexico"] = "Eastern Standard Time (Mexico)";
  WindowsZoneName["EasternStandardTime"] = "Eastern Standard Time";
  WindowsZoneName["HaitiStandardTime"] = "Haiti Standard Time";
  WindowsZoneName["CubaStandardTime"] = "Cuba Standard Time";
  WindowsZoneName["UsEasternStandardTime"] = "US Eastern Standard Time";
  WindowsZoneName["ParaguayStandardTime"] = "Paraguay Standard Time";
  WindowsZoneName["AtlanticStandardTime"] = "Atlantic Standard Time";
  WindowsZoneName["VenezuelaStandardTime"] = "Venezuela Standard Time";
  WindowsZoneName["CentralBrazilianStandardTime"] = "Central Brazilian Standard Time";
  WindowsZoneName["SaWesternStandardTime"] = "SA Western Standard Time";
  WindowsZoneName["PacificSaStandardTime"] = "Pacific SA Standard Time";
  WindowsZoneName["TurksAndCaicosStandardTime"] = "Turks And Caicos Standard Time";
  WindowsZoneName["NewfoundlandStandardTime"] = "Newfoundland Standard Time";
  WindowsZoneName["TocantinsStandardTime"] = "Tocantins Standard Time";
  WindowsZoneName["ESouthAmericaStandardTime"] = "E. South America Standard Time";
  WindowsZoneName["SaEasternStandardTime"] = "SA Eastern Standard Time";
  WindowsZoneName["ArgentinaStandardTime"] = "Argentina Standard Time";
  WindowsZoneName["GreenlandStandardTime"] = "Greenland Standard Time";
  WindowsZoneName["MontevideoStandardTime"] = "Montevideo Standard Time";
  WindowsZoneName["MagallanesStandardTime"] = "Magallanes Standard Time";
  WindowsZoneName["SaintPierreStandardTime"] = "Saint Pierre Standard Time";
  WindowsZoneName["BahiaStandardTime"] = "Bahia Standard Time";
  WindowsZoneName["UtcMinus_02"] = "UTC-02";
  WindowsZoneName["AzoresStandardTime"] = "Azores Standard Time";
  WindowsZoneName["CapeVerdeStandardTime"] = "Cape Verde Standard Time";
  WindowsZoneName["Utc"] = "UTC";
  WindowsZoneName["GmtStandardTime"] = "GMT Standard Time";
  WindowsZoneName["GreenwichStandardTime"] = "Greenwich Standard Time";
  WindowsZoneName["WEuropeStandardTime"] = "W. Europe Standard Time";
  WindowsZoneName["CentralEuropeStandardTime"] = "Central Europe Standard Time";
  WindowsZoneName["RomanceStandardTime"] = "Romance Standard Time";
  WindowsZoneName["MoroccoStandardTime"] = "Morocco Standard Time";
  WindowsZoneName["SaoTomeStandardTime"] = "Sao Tome Standard Time";
  WindowsZoneName["CentralEuropeanStandardTime"] = "Central European Standard Time";
  WindowsZoneName["WCentralAfricaStandardTime"] = "W. Central Africa Standard Time";
  WindowsZoneName["JordanStandardTime"] = "Jordan Standard Time";
  WindowsZoneName["GtbStandardTime"] = "GTB Standard Time";
  WindowsZoneName["MiddleEastStandardTime"] = "Middle East Standard Time";
  WindowsZoneName["EgyptStandardTime"] = "Egypt Standard Time";
  WindowsZoneName["EEuropeStandardTime"] = "E. Europe Standard Time";
  WindowsZoneName["SyriaStandardTime"] = "Syria Standard Time";
  WindowsZoneName["WestBankStandardTime"] = "West Bank Standard Time";
  WindowsZoneName["SouthAfricaStandardTime"] = "South Africa Standard Time";
  WindowsZoneName["FleStandardTime"] = "FLE Standard Time";
  WindowsZoneName["IsraelStandardTime"] = "Israel Standard Time";
  WindowsZoneName["KaliningradStandardTime"] = "Kaliningrad Standard Time";
  WindowsZoneName["SudanStandardTime"] = "Sudan Standard Time";
  WindowsZoneName["LibyaStandardTime"] = "Libya Standard Time";
  WindowsZoneName["NamibiaStandardTime"] = "Namibia Standard Time";
  WindowsZoneName["ArabicStandardTime"] = "Arabic Standard Time";
  WindowsZoneName["TurkeyStandardTime"] = "Turkey Standard Time";
  WindowsZoneName["ArabStandardTime"] = "Arab Standard Time";
  WindowsZoneName["BelarusStandardTime"] = "Belarus Standard Time";
  WindowsZoneName["RussianStandardTime"] = "Russian Standard Time";
  WindowsZoneName["EAfricaStandardTime"] = "E. Africa Standard Time";
  WindowsZoneName["IranStandardTime"] = "Iran Standard Time";
  WindowsZoneName["ArabianStandardTime"] = "Arabian Standard Time";
  WindowsZoneName["AstrakhanStandardTime"] = "Astrakhan Standard Time";
  WindowsZoneName["AzerbaijanStandardTime"] = "Azerbaijan Standard Time";
  WindowsZoneName["RussiaTimeZone_3"] = "Russia Time Zone 3";
  WindowsZoneName["MauritiusStandardTime"] = "Mauritius Standard Time";
  WindowsZoneName["SaratovStandardTime"] = "Saratov Standard Time";
  WindowsZoneName["GeorgianStandardTime"] = "Georgian Standard Time";
  WindowsZoneName["CaucasusStandardTime"] = "Caucasus Standard Time";
  WindowsZoneName["AfghanistanStandardTime"] = "Afghanistan Standard Time";
  WindowsZoneName["WestAsiaStandardTime"] = "West Asia Standard Time";
  WindowsZoneName["EkaterinburgStandardTime"] = "Ekaterinburg Standard Time";
  WindowsZoneName["PakistanStandardTime"] = "Pakistan Standard Time";
  WindowsZoneName["IndiaStandardTime"] = "India Standard Time";
  WindowsZoneName["SriLankaStandardTime"] = "Sri Lanka Standard Time";
  WindowsZoneName["NepalStandardTime"] = "Nepal Standard Time";
  WindowsZoneName["CentralAsiaStandardTime"] = "Central Asia Standard Time";
  WindowsZoneName["BangladeshStandardTime"] = "Bangladesh Standard Time";
  WindowsZoneName["OmskStandardTime"] = "Omsk Standard Time";
  WindowsZoneName["MyanmarStandardTime"] = "Myanmar Standard Time";
  WindowsZoneName["SeAsiaStandardTime"] = "SE Asia Standard Time";
  WindowsZoneName["AltaiStandardTime"] = "Altai Standard Time";
  WindowsZoneName["WMongoliaStandardTime"] = "W. Mongolia Standard Time";
  WindowsZoneName["NorthAsiaStandardTime"] = "North Asia Standard Time";
  WindowsZoneName["NCentralAsiaStandardTime"] = "N. Central Asia Standard Time";
  WindowsZoneName["TomskStandardTime"] = "Tomsk Standard Time";
  WindowsZoneName["ChinaStandardTime"] = "China Standard Time";
  WindowsZoneName["NorthAsiaEastStandardTime"] = "North Asia East Standard Time";
  WindowsZoneName["SingaporeStandardTime"] = "Singapore Standard Time";
  WindowsZoneName["WAustraliaStandardTime"] = "W. Australia Standard Time";
  WindowsZoneName["TaipeiStandardTime"] = "Taipei Standard Time";
  WindowsZoneName["UlaanbaatarStandardTime"] = "Ulaanbaatar Standard Time";
  WindowsZoneName["AusCentralWStandardTime"] = "Aus Central W. Standard Time";
  WindowsZoneName["TransbaikalStandardTime"] = "Transbaikal Standard Time";
  WindowsZoneName["TokyoStandardTime"] = "Tokyo Standard Time";
  WindowsZoneName["NorthKoreaStandardTime"] = "North Korea Standard Time";
  WindowsZoneName["KoreaStandardTime"] = "Korea Standard Time";
  WindowsZoneName["YakutskStandardTime"] = "Yakutsk Standard Time";
  WindowsZoneName["CenAustraliaStandardTime"] = "Cen. Australia Standard Time";
  WindowsZoneName["AusCentralStandardTime"] = "AUS Central Standard Time";
  WindowsZoneName["EAustraliaStandardTime"] = "E. Australia Standard Time";
  WindowsZoneName["AusEasternStandardTime"] = "AUS Eastern Standard Time";
  WindowsZoneName["WestPacificStandardTime"] = "West Pacific Standard Time";
  WindowsZoneName["TasmaniaStandardTime"] = "Tasmania Standard Time";
  WindowsZoneName["VladivostokStandardTime"] = "Vladivostok Standard Time";
  WindowsZoneName["LordHoweStandardTime"] = "Lord Howe Standard Time";
  WindowsZoneName["BougainvilleStandardTime"] = "Bougainville Standard Time";
  WindowsZoneName["RussiaTimeZone_10"] = "Russia Time Zone 10";
  WindowsZoneName["MagadanStandardTime"] = "Magadan Standard Time";
  WindowsZoneName["NorfolkStandardTime"] = "Norfolk Standard Time";
  WindowsZoneName["SakhalinStandardTime"] = "Sakhalin Standard Time";
  WindowsZoneName["CentralPacificStandardTime"] = "Central Pacific Standard Time";
  WindowsZoneName["RussiaTimeZone_11"] = "Russia Time Zone 11";
  WindowsZoneName["NewZealandStandardTime"] = "New Zealand Standard Time";
  WindowsZoneName["UtcMinusPlus_12"] = "UTC+12";
  WindowsZoneName["FijiStandardTime"] = "Fiji Standard Time";
  WindowsZoneName["ChathamIslandsStandardTime"] = "Chatham Islands Standard Time";
  WindowsZoneName["UtcMinusPlus_13"] = "UTC+13";
  WindowsZoneName["TongaStandardTime"] = "Tonga Standard Time";
  WindowsZoneName["SamoaStandardTime"] = "Samoa Standard Time";
  WindowsZoneName["LineIslandsStandardTime"] = "Line Islands Standard Time";
})(WindowsZoneName = exports.WindowsZoneName || (exports.WindowsZoneName = {}));
var Territory;
(function (Territory) {
  Territory["001"] = "001";
  Territory["Zz"] = "ZZ";
  Territory["As"] = "AS";
  Territory["Nu"] = "NU";
  Territory["Um"] = "UM";
  Territory["Us"] = "US";
  Territory["Ck"] = "CK";
  Territory["Pf"] = "PF";
  Territory["Mx"] = "MX";
  Territory["Pn"] = "PN";
  Territory["Ca"] = "CA";
  Territory["Bz"] = "BZ";
  Territory["Cr"] = "CR";
  Territory["Ec"] = "EC";
  Territory["Gt"] = "GT";
  Territory["Hn"] = "HN";
  Territory["Ni"] = "NI";
  Territory["Sv"] = "SV";
  Territory["Cl"] = "CL";
  Territory["Br"] = "BR";
  Territory["Co"] = "CO";
  Territory["Jm"] = "JM";
  Territory["Ky"] = "KY";
  Territory["Pa"] = "PA";
  Territory["Pe"] = "PE";
  Territory["Bs"] = "BS";
  Territory["Ht"] = "HT";
  Territory["Cu"] = "CU";
  Territory["Py"] = "PY";
  Territory["Bm"] = "BM";
  Territory["Gl"] = "GL";
  Territory["Ve"] = "VE";
  Territory["Ag"] = "AG";
  Territory["Ai"] = "AI";
  Territory["Aw"] = "AW";
  Territory["Bb"] = "BB";
  Territory["Bl"] = "BL";
  Territory["Bo"] = "BO";
  Territory["Bq"] = "BQ";
  Territory["Cw"] = "CW";
  Territory["Dm"] = "DM";
  Territory["Do"] = "DO";
  Territory["Gd"] = "GD";
  Territory["Gp"] = "GP";
  Territory["Gy"] = "GY";
  Territory["Kn"] = "KN";
  Territory["Lc"] = "LC";
  Territory["Mf"] = "MF";
  Territory["Mq"] = "MQ";
  Territory["Ms"] = "MS";
  Territory["Pr"] = "PR";
  Territory["Sx"] = "SX";
  Territory["Tt"] = "TT";
  Territory["Vc"] = "VC";
  Territory["Vg"] = "VG";
  Territory["Vi"] = "VI";
  Territory["Tc"] = "TC";
  Territory["Aq"] = "AQ";
  Territory["Fk"] = "FK";
  Territory["Gf"] = "GF";
  Territory["Sr"] = "SR";
  Territory["Ar"] = "AR";
  Territory["Uy"] = "UY";
  Territory["Pm"] = "PM";
  Territory["Gs"] = "GS";
  Territory["Pt"] = "PT";
  Territory["Cv"] = "CV";
  Territory["Es"] = "ES";
  Territory["Fo"] = "FO";
  Territory["Gb"] = "GB";
  Territory["Gg"] = "GG";
  Territory["Ie"] = "IE";
  Territory["Im"] = "IM";
  Territory["Je"] = "JE";
  Territory["Bf"] = "BF";
  Territory["Ci"] = "CI";
  Territory["Gh"] = "GH";
  Territory["Gm"] = "GM";
  Territory["Gn"] = "GN";
  Territory["Gw"] = "GW";
  Territory["Is"] = "IS";
  Territory["Lr"] = "LR";
  Territory["Ml"] = "ML";
  Territory["Mr"] = "MR";
  Territory["Sh"] = "SH";
  Territory["Sl"] = "SL";
  Territory["Sn"] = "SN";
  Territory["Tg"] = "TG";
  Territory["Ad"] = "AD";
  Territory["At"] = "AT";
  Territory["Ch"] = "CH";
  Territory["De"] = "DE";
  Territory["Gi"] = "GI";
  Territory["It"] = "IT";
  Territory["Li"] = "LI";
  Territory["Lu"] = "LU";
  Territory["Mc"] = "MC";
  Territory["Mt"] = "MT";
  Territory["Nl"] = "NL";
  Territory["No"] = "NO";
  Territory["Se"] = "SE";
  Territory["Sj"] = "SJ";
  Territory["Sm"] = "SM";
  Territory["Va"] = "VA";
  Territory["Al"] = "AL";
  Territory["Cz"] = "CZ";
  Territory["Hu"] = "HU";
  Territory["Me"] = "ME";
  Territory["Rs"] = "RS";
  Territory["Si"] = "SI";
  Territory["Sk"] = "SK";
  Territory["Be"] = "BE";
  Territory["Dk"] = "DK";
  Territory["Fr"] = "FR";
  Territory["Eh"] = "EH";
  Territory["Ma"] = "MA";
  Territory["St"] = "ST";
  Territory["Ba"] = "BA";
  Territory["Hr"] = "HR";
  Territory["Mk"] = "MK";
  Territory["Pl"] = "PL";
  Territory["Ao"] = "AO";
  Territory["Bj"] = "BJ";
  Territory["Cd"] = "CD";
  Territory["Cf"] = "CF";
  Territory["Cg"] = "CG";
  Territory["Cm"] = "CM";
  Territory["Dz"] = "DZ";
  Territory["Ga"] = "GA";
  Territory["Gq"] = "GQ";
  Territory["Ne"] = "NE";
  Territory["Ng"] = "NG";
  Territory["Td"] = "TD";
  Territory["Tn"] = "TN";
  Territory["Jo"] = "JO";
  Territory["Cy"] = "CY";
  Territory["Gr"] = "GR";
  Territory["Ro"] = "RO";
  Territory["Lb"] = "LB";
  Territory["Eg"] = "EG";
  Territory["Md"] = "MD";
  Territory["Sy"] = "SY";
  Territory["Ps"] = "PS";
  Territory["Bi"] = "BI";
  Territory["Bw"] = "BW";
  Territory["Ls"] = "LS";
  Territory["Mw"] = "MW";
  Territory["Mz"] = "MZ";
  Territory["Rw"] = "RW";
  Territory["Sz"] = "SZ";
  Territory["Za"] = "ZA";
  Territory["Zm"] = "ZM";
  Territory["Zw"] = "ZW";
  Territory["Ax"] = "AX";
  Territory["Bg"] = "BG";
  Territory["Ee"] = "EE";
  Territory["Fi"] = "FI";
  Territory["Lt"] = "LT";
  Territory["Lv"] = "LV";
  Territory["Ua"] = "UA";
  Territory["Il"] = "IL";
  Territory["Ru"] = "RU";
  Territory["Sd"] = "SD";
  Territory["Ly"] = "LY";
  Territory["Na"] = "NA";
  Territory["Iq"] = "IQ";
  Territory["Tr"] = "TR";
  Territory["Bh"] = "BH";
  Territory["Kw"] = "KW";
  Territory["Qa"] = "QA";
  Territory["Sa"] = "SA";
  Territory["Ye"] = "YE";
  Territory["By"] = "BY";
  Territory["Dj"] = "DJ";
  Territory["Er"] = "ER";
  Territory["Et"] = "ET";
  Territory["Ke"] = "KE";
  Territory["Km"] = "KM";
  Territory["Mg"] = "MG";
  Territory["So"] = "SO";
  Territory["Ss"] = "SS";
  Territory["Tz"] = "TZ";
  Territory["Ug"] = "UG";
  Territory["Yt"] = "YT";
  Territory["Ir"] = "IR";
  Territory["Ae"] = "AE";
  Territory["Om"] = "OM";
  Territory["Az"] = "AZ";
  Territory["Mu"] = "MU";
  Territory["Re"] = "RE";
  Territory["Sc"] = "SC";
  Territory["Ge"] = "GE";
  Territory["Am"] = "AM";
  Territory["Af"] = "AF";
  Territory["Kz"] = "KZ";
  Territory["Mv"] = "MV";
  Territory["Tf"] = "TF";
  Territory["Tj"] = "TJ";
  Territory["Tm"] = "TM";
  Territory["Uz"] = "UZ";
  Territory["Pk"] = "PK";
  Territory["In"] = "IN";
  Territory["Lk"] = "LK";
  Territory["Np"] = "NP";
  Territory["Cn"] = "CN";
  Territory["Io"] = "IO";
  Territory["Kg"] = "KG";
  Territory["Bd"] = "BD";
  Territory["Bt"] = "BT";
  Territory["Cc"] = "CC";
  Territory["Mm"] = "MM";
  Territory["Cx"] = "CX";
  Territory["Id"] = "ID";
  Territory["Kh"] = "KH";
  Territory["La"] = "LA";
  Territory["Th"] = "TH";
  Territory["Vn"] = "VN";
  Territory["Mn"] = "MN";
  Territory["Hk"] = "HK";
  Territory["Mo"] = "MO";
  Territory["Bn"] = "BN";
  Territory["My"] = "MY";
  Territory["Ph"] = "PH";
  Territory["Sg"] = "SG";
  Territory["Au"] = "AU";
  Territory["Tw"] = "TW";
  Territory["Jp"] = "JP";
  Territory["Pw"] = "PW";
  Territory["Tl"] = "TL";
  Territory["Kp"] = "KP";
  Territory["Kr"] = "KR";
  Territory["Fm"] = "FM";
  Territory["Gu"] = "GU";
  Territory["Mp"] = "MP";
  Territory["Pg"] = "PG";
  Territory["Nf"] = "NF";
  Territory["Nc"] = "NC";
  Territory["Sb"] = "SB";
  Territory["Vu"] = "VU";
  Territory["Nz"] = "NZ";
  Territory["Ki"] = "KI";
  Territory["Mh"] = "MH";
  Territory["Nr"] = "NR";
  Territory["Tv"] = "TV";
  Territory["Wf"] = "WF";
  Territory["Fj"] = "FJ";
  Territory["Tk"] = "TK";
  Territory["To"] = "TO";
  Territory["Ws"] = "WS";
})(Territory = exports.Territory || (exports.Territory = {}));
var IanaName;
(function (IanaName) {
  IanaName["EuropeAndorra"] = "Europe/Andorra";
  IanaName["AsiaDubai"] = "Asia/Dubai";
  IanaName["AsiaKabul"] = "Asia/Kabul";
  IanaName["AmericaAntigua"] = "America/Antigua";
  IanaName["AmericaAnguilla"] = "America/Anguilla";
  IanaName["EuropeTirane"] = "Europe/Tirane";
  IanaName["AsiaYerevan"] = "Asia/Yerevan";
  IanaName["AmericaCuracao"] = "America/Curacao";
  IanaName["AfricaLuanda"] = "Africa/Luanda";
  IanaName["AntarcticaCasey"] = "Antarctica/Casey";
  IanaName["AntarcticaDavis"] = "Antarctica/Davis";
  IanaName["AntarcticaDumontDUrville"] = "Antarctica/DumontDUrville";
  IanaName["AntarcticaMawson"] = "Antarctica/Mawson";
  IanaName["AntarcticaMcMurdo"] = "Antarctica/McMurdo";
  IanaName["AntarcticaPalmer"] = "Antarctica/Palmer";
  IanaName["AntarcticaRothera"] = "Antarctica/Rothera";
  IanaName["AntarcticaSyowa"] = "Antarctica/Syowa";
  IanaName["AntarcticaTroll"] = "Antarctica/Troll";
  IanaName["AntarcticaVostok"] = "Antarctica/Vostok";
  IanaName["AmericaBuenosAires"] = "America/Buenos_Aires";
  IanaName["AmericaArgentinaBuenosAires"] = "America/Argentina/Buenos_Aires";
  IanaName["AmericaCordoba"] = "America/Cordoba";
  IanaName["AmericaArgentinaCordoba"] = "America/Argentina/Cordoba";
  IanaName["AmericaRosario"] = "America/Rosario";
  IanaName["AmericaCatamarca"] = "America/Catamarca";
  IanaName["AmericaArgentinaCatamarca"] = "America/Argentina/Catamarca";
  IanaName["AmericaArgentinaComodRivadavia"] = "America/Argentina/ComodRivadavia";
  IanaName["AmericaArgentinaLaRioja"] = "America/Argentina/La_Rioja";
  IanaName["AmericaJujuy"] = "America/Jujuy";
  IanaName["AmericaArgentinaJujuy"] = "America/Argentina/Jujuy";
  IanaName["AmericaArgentinaSanLuis"] = "America/Argentina/San_Luis";
  IanaName["AmericaMendoza"] = "America/Mendoza";
  IanaName["AmericaArgentinaMendoza"] = "America/Argentina/Mendoza";
  IanaName["AmericaArgentinaRioGallegos"] = "America/Argentina/Rio_Gallegos";
  IanaName["AmericaArgentinaSalta"] = "America/Argentina/Salta";
  IanaName["AmericaArgentinaTucuman"] = "America/Argentina/Tucuman";
  IanaName["AmericaArgentinaSanJuan"] = "America/Argentina/San_Juan";
  IanaName["AmericaArgentinaUshuaia"] = "America/Argentina/Ushuaia";
  IanaName["PacificPagoPago"] = "Pacific/Pago_Pago";
  IanaName["PacificSamoa"] = "Pacific/Samoa";
  IanaName["UsSamoa"] = "US/Samoa";
  IanaName["EuropeVienna"] = "Europe/Vienna";
  IanaName["AustraliaAdelaide"] = "Australia/Adelaide";
  IanaName["AustraliaSouth"] = "Australia/South";
  IanaName["AustraliaBrokenHill"] = "Australia/Broken_Hill";
  IanaName["AustraliaYancowinna"] = "Australia/Yancowinna";
  IanaName["AustraliaBrisbane"] = "Australia/Brisbane";
  IanaName["AustraliaQueensland"] = "Australia/Queensland";
  IanaName["AustraliaDarwin"] = "Australia/Darwin";
  IanaName["AustraliaNorth"] = "Australia/North";
  IanaName["AustraliaEucla"] = "Australia/Eucla";
  IanaName["AustraliaHobart"] = "Australia/Hobart";
  IanaName["AustraliaTasmania"] = "Australia/Tasmania";
  IanaName["AustraliaCurrie"] = "Australia/Currie";
  IanaName["AustraliaLindeman"] = "Australia/Lindeman";
  IanaName["AustraliaLordHowe"] = "Australia/Lord_Howe";
  IanaName["AustraliaLhi"] = "Australia/LHI";
  IanaName["AustraliaMelbourne"] = "Australia/Melbourne";
  IanaName["AustraliaVictoria"] = "Australia/Victoria";
  IanaName["AntarcticaMacquarie"] = "Antarctica/Macquarie";
  IanaName["AustraliaPerth"] = "Australia/Perth";
  IanaName["AustraliaWest"] = "Australia/West";
  IanaName["AustraliaSydney"] = "Australia/Sydney";
  IanaName["AustraliaAct"] = "Australia/ACT";
  IanaName["AustraliaCanberra"] = "Australia/Canberra";
  IanaName["AustraliaNsw"] = "Australia/NSW";
  IanaName["AmericaAruba"] = "America/Aruba";
  IanaName["AsiaBaku"] = "Asia/Baku";
  IanaName["EuropeSarajevo"] = "Europe/Sarajevo";
  IanaName["AmericaBarbados"] = "America/Barbados";
  IanaName["AsiaDhaka"] = "Asia/Dhaka";
  IanaName["AsiaDacca"] = "Asia/Dacca";
  IanaName["EuropeBrussels"] = "Europe/Brussels";
  IanaName["AfricaOuagadougou"] = "Africa/Ouagadougou";
  IanaName["EuropeSofia"] = "Europe/Sofia";
  IanaName["AsiaBahrain"] = "Asia/Bahrain";
  IanaName["AfricaBujumbura"] = "Africa/Bujumbura";
  IanaName["AfricaPortoMinusNovo"] = "Africa/Porto-Novo";
  IanaName["AtlanticBermuda"] = "Atlantic/Bermuda";
  IanaName["AsiaBrunei"] = "Asia/Brunei";
  IanaName["AmericaLaPaz"] = "America/La_Paz";
  IanaName["AmericaKralendijk"] = "America/Kralendijk";
  IanaName["AmericaAraguaina"] = "America/Araguaina";
  IanaName["AmericaBelem"] = "America/Belem";
  IanaName["AmericaBoaVista"] = "America/Boa_Vista";
  IanaName["AmericaCuiaba"] = "America/Cuiaba";
  IanaName["AmericaCampoGrande"] = "America/Campo_Grande";
  IanaName["AmericaEirunepe"] = "America/Eirunepe";
  IanaName["AmericaNoronha"] = "America/Noronha";
  IanaName["BrazilDeNoronha"] = "Brazil/DeNoronha";
  IanaName["AmericaFortaleza"] = "America/Fortaleza";
  IanaName["AmericaManaus"] = "America/Manaus";
  IanaName["BrazilWest"] = "Brazil/West";
  IanaName["AmericaMaceio"] = "America/Maceio";
  IanaName["AmericaPortoVelho"] = "America/Porto_Velho";
  IanaName["AmericaRioBranco"] = "America/Rio_Branco";
  IanaName["AmericaPortoAcre"] = "America/Porto_Acre";
  IanaName["BrazilAcre"] = "Brazil/Acre";
  IanaName["AmericaRecife"] = "America/Recife";
  IanaName["AmericaSaoPaulo"] = "America/Sao_Paulo";
  IanaName["BrazilEast"] = "Brazil/East";
  IanaName["AmericaBahia"] = "America/Bahia";
  IanaName["AmericaSantarem"] = "America/Santarem";
  IanaName["AmericaNassau"] = "America/Nassau";
  IanaName["AsiaThimphu"] = "Asia/Thimphu";
  IanaName["AsiaThimbu"] = "Asia/Thimbu";
  IanaName["AfricaGaborone"] = "Africa/Gaborone";
  IanaName["EuropeMinsk"] = "Europe/Minsk";
  IanaName["AmericaBelize"] = "America/Belize";
  IanaName["AmericaCreston"] = "America/Creston";
  IanaName["AmericaEdmonton"] = "America/Edmonton";
  IanaName["CanadaMountain"] = "Canada/Mountain";
  IanaName["AmericaRainyRiver"] = "America/Rainy_River";
  IanaName["AmericaFortNelson"] = "America/Fort_Nelson";
  IanaName["AmericaGlaceBay"] = "America/Glace_Bay";
  IanaName["AmericaGooseBay"] = "America/Goose_Bay";
  IanaName["AmericaHalifax"] = "America/Halifax";
  IanaName["CanadaAtlantic"] = "Canada/Atlantic";
  IanaName["AmericaIqaluit"] = "America/Iqaluit";
  IanaName["AmericaMoncton"] = "America/Moncton";
  IanaName["AmericaPangnirtung"] = "America/Pangnirtung";
  IanaName["AmericaResolute"] = "America/Resolute";
  IanaName["AmericaRegina"] = "America/Regina";
  IanaName["CanadaEastMinusSaskatchewan"] = "Canada/East-Saskatchewan";
  IanaName["CanadaSaskatchewan"] = "Canada/Saskatchewan";
  IanaName["AmericaStJohns"] = "America/St_Johns";
  IanaName["CanadaNewfoundland"] = "Canada/Newfoundland";
  IanaName["AmericaNipigon"] = "America/Nipigon";
  IanaName["AmericaThunderBay"] = "America/Thunder_Bay";
  IanaName["AmericaToronto"] = "America/Toronto";
  IanaName["CanadaEastern"] = "Canada/Eastern";
  IanaName["AmericaVancouver"] = "America/Vancouver";
  IanaName["CanadaPacific"] = "Canada/Pacific";
  IanaName["AmericaWinnipeg"] = "America/Winnipeg";
  IanaName["CanadaCentral"] = "Canada/Central";
  IanaName["AmericaBlancMinusSablon"] = "America/Blanc-Sablon";
  IanaName["AmericaCambridgeBay"] = "America/Cambridge_Bay";
  IanaName["AmericaDawson"] = "America/Dawson";
  IanaName["AmericaDawsonCreek"] = "America/Dawson_Creek";
  IanaName["AmericaRankinInlet"] = "America/Rankin_Inlet";
  IanaName["AmericaInuvik"] = "America/Inuvik";
  IanaName["AmericaWhitehorse"] = "America/Whitehorse";
  IanaName["CanadaYukon"] = "Canada/Yukon";
  IanaName["AmericaSwiftCurrent"] = "America/Swift_Current";
  IanaName["AmericaYellowknife"] = "America/Yellowknife";
  IanaName["AmericaCoralHarbour"] = "America/Coral_Harbour";
  IanaName["AmericaAtikokan"] = "America/Atikokan";
  IanaName["IndianCocos"] = "Indian/Cocos";
  IanaName["AfricaLubumbashi"] = "Africa/Lubumbashi";
  IanaName["AfricaKinshasa"] = "Africa/Kinshasa";
  IanaName["AfricaBangui"] = "Africa/Bangui";
  IanaName["AfricaBrazzaville"] = "Africa/Brazzaville";
  IanaName["EuropeZurich"] = "Europe/Zurich";
  IanaName["AfricaAbidjan"] = "Africa/Abidjan";
  IanaName["PacificRarotonga"] = "Pacific/Rarotonga";
  IanaName["PacificEaster"] = "Pacific/Easter";
  IanaName["ChileEasterIsland"] = "Chile/EasterIsland";
  IanaName["AmericaPuntaArenas"] = "America/Punta_Arenas";
  IanaName["AmericaSantiago"] = "America/Santiago";
  IanaName["ChileContinental"] = "Chile/Continental";
  IanaName["AfricaDouala"] = "Africa/Douala";
  IanaName["AsiaShanghai"] = "Asia/Shanghai";
  IanaName["AsiaChongqing"] = "Asia/Chongqing";
  IanaName["AsiaChungking"] = "Asia/Chungking";
  IanaName["AsiaHarbin"] = "Asia/Harbin";
  IanaName["Prc"] = "PRC";
  IanaName["AsiaUrumqi"] = "Asia/Urumqi";
  IanaName["AsiaKashgar"] = "Asia/Kashgar";
  IanaName["AmericaBogota"] = "America/Bogota";
  IanaName["AmericaCostaRica"] = "America/Costa_Rica";
  IanaName["Cst6Cdt"] = "CST6CDT";
  IanaName["AmericaHavana"] = "America/Havana";
  IanaName["Cuba"] = "Cuba";
  IanaName["AtlanticCapeVerde"] = "Atlantic/Cape_Verde";
  IanaName["IndianChristmas"] = "Indian/Christmas";
  IanaName["AsiaFamagusta"] = "Asia/Famagusta";
  IanaName["AsiaNicosia"] = "Asia/Nicosia";
  IanaName["EuropeNicosia"] = "Europe/Nicosia";
  IanaName["EuropePrague"] = "Europe/Prague";
  IanaName["EuropeBerlin"] = "Europe/Berlin";
  IanaName["EuropeBusingen"] = "Europe/Busingen";
  IanaName["AfricaDjibouti"] = "Africa/Djibouti";
  IanaName["EuropeCopenhagen"] = "Europe/Copenhagen";
  IanaName["AmericaDominica"] = "America/Dominica";
  IanaName["AmericaSantoDomingo"] = "America/Santo_Domingo";
  IanaName["AfricaAlgiers"] = "Africa/Algiers";
  IanaName["PacificGalapagos"] = "Pacific/Galapagos";
  IanaName["AmericaGuayaquil"] = "America/Guayaquil";
  IanaName["EuropeTallinn"] = "Europe/Tallinn";
  IanaName["AfricaCairo"] = "Africa/Cairo";
  IanaName["Egypt"] = "Egypt";
  IanaName["AfricaElAaiun"] = "Africa/El_Aaiun";
  IanaName["AfricaAsmera"] = "Africa/Asmera";
  IanaName["AfricaAsmara"] = "Africa/Asmara";
  IanaName["AfricaCeuta"] = "Africa/Ceuta";
  IanaName["AtlanticCanary"] = "Atlantic/Canary";
  IanaName["EuropeMadrid"] = "Europe/Madrid";
  IanaName["Est5Edt"] = "EST5EDT";
  IanaName["AfricaAddisAbaba"] = "Africa/Addis_Ababa";
  IanaName["EuropeHelsinki"] = "Europe/Helsinki";
  IanaName["EuropeMariehamn"] = "Europe/Mariehamn";
  IanaName["PacificFiji"] = "Pacific/Fiji";
  IanaName["AtlanticStanley"] = "Atlantic/Stanley";
  IanaName["PacificKosrae"] = "Pacific/Kosrae";
  IanaName["PacificPonape"] = "Pacific/Ponape";
  IanaName["PacificPohnpei"] = "Pacific/Pohnpei";
  IanaName["PacificTruk"] = "Pacific/Truk";
  IanaName["PacificChuuk"] = "Pacific/Chuuk";
  IanaName["PacificYap"] = "Pacific/Yap";
  IanaName["AtlanticFaeroe"] = "Atlantic/Faeroe";
  IanaName["AtlanticFaroe"] = "Atlantic/Faroe";
  IanaName["EuropeParis"] = "Europe/Paris";
  IanaName["AfricaLibreville"] = "Africa/Libreville";
  IanaName["AsiaGaza"] = "Asia/Gaza";
  IanaName["EuropeLondon"] = "Europe/London";
  IanaName["EuropeBelfast"] = "Europe/Belfast";
  IanaName["Gb"] = "GB";
  IanaName["GbMinusEire"] = "GB-Eire";
  IanaName["AmericaGrenada"] = "America/Grenada";
  IanaName["AsiaTbilisi"] = "Asia/Tbilisi";
  IanaName["AmericaCayenne"] = "America/Cayenne";
  IanaName["EuropeGuernsey"] = "Europe/Guernsey";
  IanaName["AfricaAccra"] = "Africa/Accra";
  IanaName["EuropeGibraltar"] = "Europe/Gibraltar";
  IanaName["AmericaDanmarkshavn"] = "America/Danmarkshavn";
  IanaName["AmericaGodthab"] = "America/Godthab";
  IanaName["AmericaScoresbysund"] = "America/Scoresbysund";
  IanaName["AmericaThule"] = "America/Thule";
  IanaName["AfricaBanjul"] = "Africa/Banjul";
  IanaName["EtcGmt"] = "Etc/GMT";
  IanaName["EtcGmtMinusPlus_0"] = "Etc/GMT+0";
  IanaName["EtcGmtMinus_0"] = "Etc/GMT-0";
  IanaName["EtcGmt0"] = "Etc/GMT0";
  IanaName["EtcGreenwich"] = "Etc/Greenwich";
  IanaName["Gmt"] = "GMT";
  IanaName["GmtMinusPlus_0"] = "GMT+0";
  IanaName["GmtMinus_0"] = "GMT-0";
  IanaName["Gmt0"] = "GMT0";
  IanaName["Greenwich"] = "Greenwich";
  IanaName["AfricaConakry"] = "Africa/Conakry";
  IanaName["AmericaGuadeloupe"] = "America/Guadeloupe";
  IanaName["AmericaMarigot"] = "America/Marigot";
  IanaName["AmericaStBarthelemy"] = "America/St_Barthelemy";
  IanaName["AfricaMalabo"] = "Africa/Malabo";
  IanaName["EuropeAthens"] = "Europe/Athens";
  IanaName["AtlanticSouthGeorgia"] = "Atlantic/South_Georgia";
  IanaName["AmericaGuatemala"] = "America/Guatemala";
  IanaName["PacificGuam"] = "Pacific/Guam";
  IanaName["AfricaBissau"] = "Africa/Bissau";
  IanaName["AmericaGuyana"] = "America/Guyana";
  IanaName["AsiaHebron"] = "Asia/Hebron";
  IanaName["AsiaHongKong"] = "Asia/Hong_Kong";
  IanaName["Hongkong"] = "Hongkong";
  IanaName["AmericaTegucigalpa"] = "America/Tegucigalpa";
  IanaName["EuropeZagreb"] = "Europe/Zagreb";
  IanaName["AmericaPortMinusAuPrince"] = "America/Port-au-Prince";
  IanaName["EuropeBudapest"] = "Europe/Budapest";
  IanaName["AsiaJayapura"] = "Asia/Jayapura";
  IanaName["AsiaJakarta"] = "Asia/Jakarta";
  IanaName["AsiaMakassar"] = "Asia/Makassar";
  IanaName["AsiaUjungPandang"] = "Asia/Ujung_Pandang";
  IanaName["AsiaPontianak"] = "Asia/Pontianak";
  IanaName["EuropeDublin"] = "Europe/Dublin";
  IanaName["Eire"] = "Eire";
  IanaName["EuropeIsleOfMan"] = "Europe/Isle_of_Man";
  IanaName["AsiaCalcutta"] = "Asia/Calcutta";
  IanaName["AsiaKolkata"] = "Asia/Kolkata";
  IanaName["IndianChagos"] = "Indian/Chagos";
  IanaName["AsiaBaghdad"] = "Asia/Baghdad";
  IanaName["AsiaTehran"] = "Asia/Tehran";
  IanaName["Iran"] = "Iran";
  IanaName["AtlanticReykjavik"] = "Atlantic/Reykjavik";
  IanaName["Iceland"] = "Iceland";
  IanaName["EuropeRome"] = "Europe/Rome";
  IanaName["AsiaJerusalem"] = "Asia/Jerusalem";
  IanaName["AsiaTelAviv"] = "Asia/Tel_Aviv";
  IanaName["Israel"] = "Israel";
  IanaName["EuropeJersey"] = "Europe/Jersey";
  IanaName["AmericaJamaica"] = "America/Jamaica";
  IanaName["Jamaica"] = "Jamaica";
  IanaName["AsiaAmman"] = "Asia/Amman";
  IanaName["AsiaTokyo"] = "Asia/Tokyo";
  IanaName["Japan"] = "Japan";
  IanaName["AfricaNairobi"] = "Africa/Nairobi";
  IanaName["AsiaBishkek"] = "Asia/Bishkek";
  IanaName["AsiaPhnomPenh"] = "Asia/Phnom_Penh";
  IanaName["PacificKiritimati"] = "Pacific/Kiritimati";
  IanaName["PacificEnderbury"] = "Pacific/Enderbury";
  IanaName["PacificTarawa"] = "Pacific/Tarawa";
  IanaName["IndianComoro"] = "Indian/Comoro";
  IanaName["AmericaStKitts"] = "America/St_Kitts";
  IanaName["AsiaPyongyang"] = "Asia/Pyongyang";
  IanaName["AsiaSeoul"] = "Asia/Seoul";
  IanaName["Rok"] = "ROK";
  IanaName["AsiaKuwait"] = "Asia/Kuwait";
  IanaName["AmericaCayman"] = "America/Cayman";
  IanaName["AsiaAqtau"] = "Asia/Aqtau";
  IanaName["AsiaAqtobe"] = "Asia/Aqtobe";
  IanaName["AsiaAlmaty"] = "Asia/Almaty";
  IanaName["AsiaAtyrau"] = "Asia/Atyrau";
  IanaName["AsiaQostanay"] = "Asia/Qostanay";
  IanaName["AsiaQyzylorda"] = "Asia/Qyzylorda";
  IanaName["AsiaOral"] = "Asia/Oral";
  IanaName["AsiaVientiane"] = "Asia/Vientiane";
  IanaName["AsiaBeirut"] = "Asia/Beirut";
  IanaName["AmericaStLucia"] = "America/St_Lucia";
  IanaName["EuropeVaduz"] = "Europe/Vaduz";
  IanaName["AsiaColombo"] = "Asia/Colombo";
  IanaName["AfricaMonrovia"] = "Africa/Monrovia";
  IanaName["AfricaMaseru"] = "Africa/Maseru";
  IanaName["EuropeVilnius"] = "Europe/Vilnius";
  IanaName["EuropeLuxembourg"] = "Europe/Luxembourg";
  IanaName["EuropeRiga"] = "Europe/Riga";
  IanaName["AfricaTripoli"] = "Africa/Tripoli";
  IanaName["Libya"] = "Libya";
  IanaName["AfricaCasablanca"] = "Africa/Casablanca";
  IanaName["EuropeMonaco"] = "Europe/Monaco";
  IanaName["EuropeChisinau"] = "Europe/Chisinau";
  IanaName["EuropeTiraspol"] = "Europe/Tiraspol";
  IanaName["EuropePodgorica"] = "Europe/Podgorica";
  IanaName["IndianAntananarivo"] = "Indian/Antananarivo";
  IanaName["PacificKwajalein"] = "Pacific/Kwajalein";
  IanaName["Kwajalein"] = "Kwajalein";
  IanaName["PacificMajuro"] = "Pacific/Majuro";
  IanaName["EuropeSkopje"] = "Europe/Skopje";
  IanaName["AfricaBamako"] = "Africa/Bamako";
  IanaName["AfricaTimbuktu"] = "Africa/Timbuktu";
  IanaName["AsiaRangoon"] = "Asia/Rangoon";
  IanaName["AsiaYangon"] = "Asia/Yangon";
  IanaName["AsiaChoibalsan"] = "Asia/Choibalsan";
  IanaName["AsiaHovd"] = "Asia/Hovd";
  IanaName["AsiaUlaanbaatar"] = "Asia/Ulaanbaatar";
  IanaName["AsiaUlanBator"] = "Asia/Ulan_Bator";
  IanaName["AsiaMacau"] = "Asia/Macau";
  IanaName["AsiaMacao"] = "Asia/Macao";
  IanaName["PacificSaipan"] = "Pacific/Saipan";
  IanaName["AmericaMartinique"] = "America/Martinique";
  IanaName["AfricaNouakchott"] = "Africa/Nouakchott";
  IanaName["AmericaMontserrat"] = "America/Montserrat";
  IanaName["Mst7Mdt"] = "MST7MDT";
  IanaName["EuropeMalta"] = "Europe/Malta";
  IanaName["IndianMauritius"] = "Indian/Mauritius";
  IanaName["IndianMaldives"] = "Indian/Maldives";
  IanaName["AfricaBlantyre"] = "Africa/Blantyre";
  IanaName["AmericaChihuahua"] = "America/Chihuahua";
  IanaName["AmericaCancun"] = "America/Cancun";
  IanaName["AmericaHermosillo"] = "America/Hermosillo";
  IanaName["AmericaMatamoros"] = "America/Matamoros";
  IanaName["AmericaMexicoCity"] = "America/Mexico_City";
  IanaName["MexicoGeneral"] = "Mexico/General";
  IanaName["AmericaMerida"] = "America/Merida";
  IanaName["AmericaMonterrey"] = "America/Monterrey";
  IanaName["AmericaMazatlan"] = "America/Mazatlan";
  IanaName["MexicoBajaSur"] = "Mexico/BajaSur";
  IanaName["AmericaOjinaga"] = "America/Ojinaga";
  IanaName["AmericaBahiaBanderas"] = "America/Bahia_Banderas";
  IanaName["AmericaSantaIsabel"] = "America/Santa_Isabel";
  IanaName["AmericaTijuana"] = "America/Tijuana";
  IanaName["AmericaEnsenada"] = "America/Ensenada";
  IanaName["MexicoBajaNorte"] = "Mexico/BajaNorte";
  IanaName["AsiaKuching"] = "Asia/Kuching";
  IanaName["AsiaKualaLumpur"] = "Asia/Kuala_Lumpur";
  IanaName["AfricaMaputo"] = "Africa/Maputo";
  IanaName["AfricaWindhoek"] = "Africa/Windhoek";
  IanaName["PacificNoumea"] = "Pacific/Noumea";
  IanaName["AfricaNiamey"] = "Africa/Niamey";
  IanaName["PacificNorfolk"] = "Pacific/Norfolk";
  IanaName["AfricaLagos"] = "Africa/Lagos";
  IanaName["AmericaManagua"] = "America/Managua";
  IanaName["EuropeAmsterdam"] = "Europe/Amsterdam";
  IanaName["EuropeOslo"] = "Europe/Oslo";
  IanaName["AsiaKatmandu"] = "Asia/Katmandu";
  IanaName["AsiaKathmandu"] = "Asia/Kathmandu";
  IanaName["PacificNauru"] = "Pacific/Nauru";
  IanaName["PacificNiue"] = "Pacific/Niue";
  IanaName["PacificAuckland"] = "Pacific/Auckland";
  IanaName["AntarcticaSouthPole"] = "Antarctica/South_Pole";
  IanaName["Nz"] = "NZ";
  IanaName["PacificChatham"] = "Pacific/Chatham";
  IanaName["NzMinusChat"] = "NZ-CHAT";
  IanaName["AsiaMuscat"] = "Asia/Muscat";
  IanaName["AmericaPanama"] = "America/Panama";
  IanaName["AmericaLima"] = "America/Lima";
  IanaName["PacificGambier"] = "Pacific/Gambier";
  IanaName["PacificMarquesas"] = "Pacific/Marquesas";
  IanaName["PacificTahiti"] = "Pacific/Tahiti";
  IanaName["PacificPortMoresby"] = "Pacific/Port_Moresby";
  IanaName["PacificBougainville"] = "Pacific/Bougainville";
  IanaName["AsiaManila"] = "Asia/Manila";
  IanaName["AsiaKarachi"] = "Asia/Karachi";
  IanaName["EuropeWarsaw"] = "Europe/Warsaw";
  IanaName["Poland"] = "Poland";
  IanaName["AmericaMiquelon"] = "America/Miquelon";
  IanaName["PacificPitcairn"] = "Pacific/Pitcairn";
  IanaName["AmericaPuertoRico"] = "America/Puerto_Rico";
  IanaName["Pst8Pdt"] = "PST8PDT";
  IanaName["AtlanticMadeira"] = "Atlantic/Madeira";
  IanaName["EuropeLisbon"] = "Europe/Lisbon";
  IanaName["Portugal"] = "Portugal";
  IanaName["AtlanticAzores"] = "Atlantic/Azores";
  IanaName["PacificPalau"] = "Pacific/Palau";
  IanaName["AmericaAsuncion"] = "America/Asuncion";
  IanaName["AsiaQatar"] = "Asia/Qatar";
  IanaName["IndianReunion"] = "Indian/Reunion";
  IanaName["EuropeBucharest"] = "Europe/Bucharest";
  IanaName["EuropeBelgrade"] = "Europe/Belgrade";
  IanaName["EuropeAstrakhan"] = "Europe/Astrakhan";
  IanaName["AsiaBarnaul"] = "Asia/Barnaul";
  IanaName["AsiaChita"] = "Asia/Chita";
  IanaName["AsiaAnadyr"] = "Asia/Anadyr";
  IanaName["AsiaMagadan"] = "Asia/Magadan";
  IanaName["AsiaIrkutsk"] = "Asia/Irkutsk";
  IanaName["EuropeKaliningrad"] = "Europe/Kaliningrad";
  IanaName["AsiaKhandyga"] = "Asia/Khandyga";
  IanaName["AsiaKrasnoyarsk"] = "Asia/Krasnoyarsk";
  IanaName["EuropeSamara"] = "Europe/Samara";
  IanaName["EuropeKirov"] = "Europe/Kirov";
  IanaName["EuropeMoscow"] = "Europe/Moscow";
  IanaName["WMinusSu"] = "W-SU";
  IanaName["AsiaNovokuznetsk"] = "Asia/Novokuznetsk";
  IanaName["AsiaOmsk"] = "Asia/Omsk";
  IanaName["AsiaNovosibirsk"] = "Asia/Novosibirsk";
  IanaName["AsiaKamchatka"] = "Asia/Kamchatka";
  IanaName["EuropeSaratov"] = "Europe/Saratov";
  IanaName["AsiaSrednekolymsk"] = "Asia/Srednekolymsk";
  IanaName["AsiaTomsk"] = "Asia/Tomsk";
  IanaName["EuropeUlyanovsk"] = "Europe/Ulyanovsk";
  IanaName["AsiaUstMinusNera"] = "Asia/Ust-Nera";
  IanaName["AsiaSakhalin"] = "Asia/Sakhalin";
  IanaName["EuropeVolgograd"] = "Europe/Volgograd";
  IanaName["AsiaVladivostok"] = "Asia/Vladivostok";
  IanaName["AsiaYekaterinburg"] = "Asia/Yekaterinburg";
  IanaName["AsiaYakutsk"] = "Asia/Yakutsk";
  IanaName["AfricaKigali"] = "Africa/Kigali";
  IanaName["AsiaRiyadh"] = "Asia/Riyadh";
  IanaName["PacificGuadalcanal"] = "Pacific/Guadalcanal";
  IanaName["IndianMahe"] = "Indian/Mahe";
  IanaName["AfricaKhartoum"] = "Africa/Khartoum";
  IanaName["EuropeStockholm"] = "Europe/Stockholm";
  IanaName["AsiaSingapore"] = "Asia/Singapore";
  IanaName["Singapore"] = "Singapore";
  IanaName["AtlanticStHelena"] = "Atlantic/St_Helena";
  IanaName["EuropeLjubljana"] = "Europe/Ljubljana";
  IanaName["ArcticLongyearbyen"] = "Arctic/Longyearbyen";
  IanaName["AtlanticJanMayen"] = "Atlantic/Jan_Mayen";
  IanaName["EuropeBratislava"] = "Europe/Bratislava";
  IanaName["AfricaFreetown"] = "Africa/Freetown";
  IanaName["EuropeSanMarino"] = "Europe/San_Marino";
  IanaName["AfricaDakar"] = "Africa/Dakar";
  IanaName["AfricaMogadishu"] = "Africa/Mogadishu";
  IanaName["AmericaParamaribo"] = "America/Paramaribo";
  IanaName["AfricaJuba"] = "Africa/Juba";
  IanaName["AfricaSaoTome"] = "Africa/Sao_Tome";
  IanaName["AmericaElSalvador"] = "America/El_Salvador";
  IanaName["AmericaLowerPrinces"] = "America/Lower_Princes";
  IanaName["AsiaDamascus"] = "Asia/Damascus";
  IanaName["AfricaMbabane"] = "Africa/Mbabane";
  IanaName["AmericaGrandTurk"] = "America/Grand_Turk";
  IanaName["AfricaNdjamena"] = "Africa/Ndjamena";
  IanaName["IndianKerguelen"] = "Indian/Kerguelen";
  IanaName["AfricaLome"] = "Africa/Lome";
  IanaName["AsiaBangkok"] = "Asia/Bangkok";
  IanaName["AsiaDushanbe"] = "Asia/Dushanbe";
  IanaName["PacificFakaofo"] = "Pacific/Fakaofo";
  IanaName["AsiaDili"] = "Asia/Dili";
  IanaName["AsiaAshgabat"] = "Asia/Ashgabat";
  IanaName["AsiaAshkhabad"] = "Asia/Ashkhabad";
  IanaName["AfricaTunis"] = "Africa/Tunis";
  IanaName["PacificTongatapu"] = "Pacific/Tongatapu";
  IanaName["EuropeIstanbul"] = "Europe/Istanbul";
  IanaName["AsiaIstanbul"] = "Asia/Istanbul";
  IanaName["Turkey"] = "Turkey";
  IanaName["AmericaPortOfSpain"] = "America/Port_of_Spain";
  IanaName["PacificFunafuti"] = "Pacific/Funafuti";
  IanaName["AsiaTaipei"] = "Asia/Taipei";
  IanaName["Roc"] = "ROC";
  IanaName["AfricaDarEsSalaam"] = "Africa/Dar_es_Salaam";
  IanaName["EuropeKiev"] = "Europe/Kiev";
  IanaName["EuropeZaporozhye"] = "Europe/Zaporozhye";
  IanaName["EuropeSimferopol"] = "Europe/Simferopol";
  IanaName["EuropeUzhgorod"] = "Europe/Uzhgorod";
  IanaName["AfricaKampala"] = "Africa/Kampala";
  IanaName["PacificWake"] = "Pacific/Wake";
  IanaName["PacificJohnston"] = "Pacific/Johnston";
  IanaName["PacificMidway"] = "Pacific/Midway";
  IanaName["EtcUnknown"] = "Etc/Unknown";
  IanaName["AmericaAdak"] = "America/Adak";
  IanaName["AmericaAtka"] = "America/Atka";
  IanaName["UsAleutian"] = "US/Aleutian";
  IanaName["AmericaIndianaMarengo"] = "America/Indiana/Marengo";
  IanaName["AmericaAnchorage"] = "America/Anchorage";
  IanaName["UsAlaska"] = "US/Alaska";
  IanaName["AmericaBoise"] = "America/Boise";
  IanaName["AmericaChicago"] = "America/Chicago";
  IanaName["UsCentral"] = "US/Central";
  IanaName["AmericaDenver"] = "America/Denver";
  IanaName["AmericaShiprock"] = "America/Shiprock";
  IanaName["Navajo"] = "Navajo";
  IanaName["UsMountain"] = "US/Mountain";
  IanaName["AmericaDetroit"] = "America/Detroit";
  IanaName["UsMichigan"] = "US/Michigan";
  IanaName["PacificHonolulu"] = "Pacific/Honolulu";
  IanaName["UsHawaii"] = "US/Hawaii";
  IanaName["AmericaIndianapolis"] = "America/Indianapolis";
  IanaName["AmericaFortWayne"] = "America/Fort_Wayne";
  IanaName["AmericaIndianaIndianapolis"] = "America/Indiana/Indianapolis";
  IanaName["UsEastMinusIndiana"] = "US/East-Indiana";
  IanaName["AmericaIndianaVevay"] = "America/Indiana/Vevay";
  IanaName["AmericaJuneau"] = "America/Juneau";
  IanaName["AmericaIndianaKnox"] = "America/Indiana/Knox";
  IanaName["AmericaKnoxIn"] = "America/Knox_IN";
  IanaName["UsIndianaMinusStarke"] = "US/Indiana-Starke";
  IanaName["AmericaLosAngeles"] = "America/Los_Angeles";
  IanaName["UsPacific"] = "US/Pacific";
  IanaName["UsPacificMinusNew"] = "US/Pacific-New";
  IanaName["AmericaLouisville"] = "America/Louisville";
  IanaName["AmericaKentuckyLouisville"] = "America/Kentucky/Louisville";
  IanaName["AmericaMenominee"] = "America/Menominee";
  IanaName["AmericaMetlakatla"] = "America/Metlakatla";
  IanaName["AmericaKentuckyMonticello"] = "America/Kentucky/Monticello";
  IanaName["AmericaNorthDakotaCenter"] = "America/North_Dakota/Center";
  IanaName["AmericaNorthDakotaNewSalem"] = "America/North_Dakota/New_Salem";
  IanaName["AmericaNewYork"] = "America/New_York";
  IanaName["UsEastern"] = "US/Eastern";
  IanaName["AmericaIndianaVincennes"] = "America/Indiana/Vincennes";
  IanaName["AmericaNome"] = "America/Nome";
  IanaName["AmericaPhoenix"] = "America/Phoenix";
  IanaName["UsArizona"] = "US/Arizona";
  IanaName["AmericaSitka"] = "America/Sitka";
  IanaName["AmericaIndianaTellCity"] = "America/Indiana/Tell_City";
  IanaName["AmericaIndianaWinamac"] = "America/Indiana/Winamac";
  IanaName["AmericaIndianaPetersburg"] = "America/Indiana/Petersburg";
  IanaName["AmericaNorthDakotaBeulah"] = "America/North_Dakota/Beulah";
  IanaName["AmericaYakutat"] = "America/Yakutat";
  IanaName["EtcUtc"] = "Etc/UTC";
  IanaName["EtcUct"] = "Etc/UCT";
  IanaName["EtcUniversal"] = "Etc/Universal";
  IanaName["EtcZulu"] = "Etc/Zulu";
  IanaName["Uct"] = "UCT";
  IanaName["Utc"] = "UTC";
  IanaName["Universal"] = "Universal";
  IanaName["Zulu"] = "Zulu";
  IanaName["EtcGmtMinus_1"] = "Etc/GMT-1";
  IanaName["EtcGmtMinus_2"] = "Etc/GMT-2";
  IanaName["EtcGmtMinus_3"] = "Etc/GMT-3";
  IanaName["EtcGmtMinus_4"] = "Etc/GMT-4";
  IanaName["EtcGmtMinus_5"] = "Etc/GMT-5";
  IanaName["EtcGmtMinus_6"] = "Etc/GMT-6";
  IanaName["EtcGmtMinus_7"] = "Etc/GMT-7";
  IanaName["EtcGmtMinus_8"] = "Etc/GMT-8";
  IanaName["EtcGmtMinus_9"] = "Etc/GMT-9";
  IanaName["EtcGmtMinus_10"] = "Etc/GMT-10";
  IanaName["EtcGmtMinus_11"] = "Etc/GMT-11";
  IanaName["EtcGmtMinus_12"] = "Etc/GMT-12";
  IanaName["EtcGmtMinus_13"] = "Etc/GMT-13";
  IanaName["EtcGmtMinus_14"] = "Etc/GMT-14";
  IanaName["EtcGmtMinusPlus_1"] = "Etc/GMT+1";
  IanaName["EtcGmtMinusPlus_2"] = "Etc/GMT+2";
  IanaName["EtcGmtMinusPlus_3"] = "Etc/GMT+3";
  IanaName["EtcGmtMinusPlus_4"] = "Etc/GMT+4";
  IanaName["EtcGmtMinusPlus_5"] = "Etc/GMT+5";
  IanaName["Est"] = "EST";
  IanaName["EtcGmtMinusPlus_6"] = "Etc/GMT+6";
  IanaName["EtcGmtMinusPlus_7"] = "Etc/GMT+7";
  IanaName["Mst"] = "MST";
  IanaName["EtcGmtMinusPlus_8"] = "Etc/GMT+8";
  IanaName["EtcGmtMinusPlus_9"] = "Etc/GMT+9";
  IanaName["EtcGmtMinusPlus_10"] = "Etc/GMT+10";
  IanaName["Hst"] = "HST";
  IanaName["EtcGmtMinusPlus_11"] = "Etc/GMT+11";
  IanaName["EtcGmtMinusPlus_12"] = "Etc/GMT+12";
  IanaName["AmericaMontevideo"] = "America/Montevideo";
  IanaName["AsiaSamarkand"] = "Asia/Samarkand";
  IanaName["AsiaTashkent"] = "Asia/Tashkent";
  IanaName["EuropeVatican"] = "Europe/Vatican";
  IanaName["AmericaStVincent"] = "America/St_Vincent";
  IanaName["AmericaCaracas"] = "America/Caracas";
  IanaName["AmericaTortola"] = "America/Tortola";
  IanaName["AmericaStThomas"] = "America/St_Thomas";
  IanaName["AmericaVirgin"] = "America/Virgin";
  IanaName["AsiaSaigon"] = "Asia/Saigon";
  IanaName["AsiaHoChiMinh"] = "Asia/Ho_Chi_Minh";
  IanaName["PacificEfate"] = "Pacific/Efate";
  IanaName["PacificWallis"] = "Pacific/Wallis";
  IanaName["PacificApia"] = "Pacific/Apia";
  IanaName["AsiaAden"] = "Asia/Aden";
  IanaName["IndianMayotte"] = "Indian/Mayotte";
  IanaName["AfricaJohannesburg"] = "Africa/Johannesburg";
  IanaName["AfricaLusaka"] = "Africa/Lusaka";
  IanaName["AfricaHarare"] = "Africa/Harare";
})(IanaName = exports.IanaName || (exports.IanaName = {}));